import { 
    JOBS_TEAM_SET
        } from "./actionTypes"


const initialState = {
    error:"",
    status: false,
}




 const JobsTeamVivew = (state = initialState,action) => {

  switch (action.type) {

        case JOBS_TEAM_SET:
          return {
            ...state,
            action
          };
   
      default:
        return { ...state };
  }


}


export default JobsTeamVivew        